import React from 'react';

export const TextInput = props => {
	const { id, type, placeholder, className, label, value, error, disabled, changeAction, name } = props;
	
	return (
		<div className={`input-field text-input ${className}`}>
			{ error ? <div className="error-text">{error}</div> : null }
			<input
				id={id}
				type={type || "text"}
				value={value}
				onChange={changeAction || console.log("NOT IMPLEMENTED")}
				placeholder={placeholder}
				name={name}
				autoComplete={true}
			/>
			<label htmlFor={id}>{label}</label>
		</div>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/TextInput.js